import _ from 'lodash';
import pluralize from 'pluralize';
import React, {FunctionComponent, useContext} from 'react';
import {useDispatch} from 'react-redux';
import {AddIcon} from '@treez-ui/core/icons';
import {Button, ButtonClass} from '@treez-ui/core/buttons';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {
    CurrentSelectionStateContext,
    DispatchCurrentSelectionAction,
    TypeOfSelectAction,
} from '~/lib/selectedProductContext';
import ActionBar from '~/modules/widgets/actionBar/ActionBar';
import {informUserOfErrorAddingProducts} from '~/redux/actionCreators/UserFeedbackCreators';

interface Props {
    handleAddProducts: (products: ProductInCatalog[]) => void;
}

export const BrandTreezActions: FunctionComponent<Props> = (props: Props) => {
    const {handleAddProducts} = props;

    const selectedProducts = useContext(CurrentSelectionStateContext);
    const dispatchSelectedProducts = DispatchCurrentSelectionAction();

    const dispatch = useDispatch();

    const clearSelection = () => {
        dispatchSelectedProducts({
            type: TypeOfSelectAction.CLEAR,
        });
    };

    const addProductsToCentralCatalog = async () => {
        try {
            await handleAddProducts(selectedProducts);
        } catch (error) {
            dispatch(informUserOfErrorAddingProducts(error.message, selectedProducts.length));
        }
    };

    const addProductsToStoresButton = (
        <Button
            key="add-product-to-central-catalog-button"
            buttonClass={ButtonClass.QUIET}
            icon={<AddIcon />}
            text={`Add ${pluralize('product', selectedProducts.length)}`}
            onClick={() => addProductsToCentralCatalog()}
        />
    );

    return (
        <div className={`actionBarContainer ${selectedProducts.length > 0 ? 'selected' : ''}`}>
            <ActionBar
                actions={[addProductsToStoresButton]}
                clearSelection={clearSelection}
                numberSelected={selectedProducts.length}
            />
        </div>
    );
};

export default BrandTreezActions;
